import { TabGroup, theme, typographyRem } from '@by-miles/bymiles-styles'
import { DataLayer } from '@by-miles/data-layer'
import React, { useState } from 'react'

import { AppFeaturesStyles } from './AppFeaturesStyles'
import { ReactComponent as MakeEasierConnected } from './images/make-easier.svg'
import { ReactComponent as MakeEasierTracker } from './images/make-easier-tracker.svg'
import { ReactComponent as TakeControl } from './images/take-control.svg'
import { ReactComponent as TrackSpending } from './images/track-spending.svg'
const { h4: H4, h5: H5, paragraphLead: ParagraphLead } = typographyRem

interface AppFeaturesProps {
  isTrackerless: boolean
}

export const AppFeatures = ({ isTrackerless }: AppFeaturesProps) => {
  const [selectedTab, setSelectedTab] = useState<number>(1)

  const features = [
    {
      color: theme.tints.tangerine,
      image: <TrackSpending className="image" />,
      title: 'Track spending.',
      text: 'Our app makes it easy to see how much each journey costs so you can stay on top of things (and give yourself the odd tap on the back).',
    },
    {
      color: theme.tints.amber,
      image: <TakeControl className="image" />,
      title: 'Stay in complete control.',
      text: 'Clear costs, reminders and self-serve features to help you stay on top of spending and making changes with ease.',
    },
    {
      color: theme.tints.cyan,
      image: isTrackerless ? <MakeEasierConnected className="square-image" /> : <MakeEasierTracker className="image" />,
      title: 'Make life easier.',
      text: isTrackerless
        ? 'Estimate the cost of a journey and get help when you need it via our chat.'
        : 'Get toll zone alerts, find your car if it’s lost or stolen, and chat to our award-winning team when you need help.',
    },
  ]
  const { color, image, title, text } = features[selectedTab - 1]
  return (
    <AppFeaturesStyles color={color}>
      <H4 className="component-heading">
        Keep track in our app…
        <br />
        And then some.
      </H4>
      <div className="app-features-container">
        <div className="features-image-container">{image}</div>
        <div className="features-content-container">
          <H5>{title}</H5>
          <ParagraphLead className="content-text">{text}</ParagraphLead>
          <TabGroup
            tabs={[{ label: 'Track spending' }, { label: 'Take control' }, { label: 'make life easier' }]}
            onTabClick={(tab: number) => {
              DataLayer.customEvent({
                eventName: `click app feature ${tab}`,
                section: 'how',
              })
              setSelectedTab(tab)
            }}
            activeTabNumber={selectedTab}
            breakIntoRow={false}
          />
        </div>
      </div>
    </AppFeaturesStyles>
  )
}
